<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/parcels')">Paquetes</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Generar Envíos</a>
  </div>
  <h1 class="ui header"><img class="ui image" src="../assets/parcels.png">
    <div class="content">Generar Envíos</div>
  </h1>
  <div v-if="error" class="ui warning message"> 
    <h4 class="ui dividing header">Error</h4>
      <p v-if="msg_error"> {{ this.msg_error }} </p>
  </div>
  <div v-if="(!apmOptions) && !error" class="ui active centered inline loader"></div>
  <div v-if="apmOptions && !error" class="ui stackable two column divided grid container">
    <div class="row">
      <div class="column">
        <h4 class="ui dividing header">Datos del paquete</h4>
        <form class="ui form" @submit.prevent="generateParcel">
          <div class="field">
            <label>Locker *</label>
            <sui-dropdown :options="apmOptions" placeholder="Locker" selection v-model="parcelInfo.place_id" @change="changeSelection($event)" required/>
          </div>
          <div class="field">
            <label>Nombre del cliente *</label>
            <input type="text" v-model="parcelInfo.name" placeholder="Nombre" required>
          </div>
<!--           <div class="two fields">-->
            <div class="field">
              <label>Teléfono del cliente * </label>
              <input type="text" v-model="parcelInfo.phone" placeholder="Teléfono" required pattern="(\+34|0034|34)?[ -]*(6|7)[ -]*([0-9][ -]*){8}">
            </div>
<!--             <div class="field">
              <label>Email del cliente</label>
              <input type="email" v-model="parcelInfo.email" placeholder="Email" pattern="^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$">
            </div>
          </div> -->
          <div class="field" v-if="!robot">
            <label>Tamaño del paquete *</label>
            <div v-if="(parcelSizes.length==0) && !error" class="ui active centered inline loader small"></div>
            <div v-if="(parcelSizes.length>0) && !error" class="ui stackable divided grid container">
              <sizeModule :theSizes="parcelSizes" :defaultSelected="defaultSelected" @on-size-selected="sizeSelected($event)" ></sizeModule>
              <!-- <sizeModule :theSizes="parcelSizes" :defaultSelected="defaultSelected" @on-size-selected="parcelInfo.slot_size=$event" ></sizeModule> -->
            </div>
          </div> 
           <div class="field">
            <label>* Campos obligatorios</label>
          </div>
          
          <button id="generate" class="ui button fluid secondary" type="submit">Generar Envío</button>
        </form>
      </div>
      <div class="column">
      <!-- <div v-if="generating" class="ui active centered inline loader"></div> -->
        <div v-if='dropoff_code' class="ui segment">
          <a class="ui red ribbon label">Envío generado</a>
          <h4>Taquilla</h4>
          <p>{{ apm_selected_gen }}</p>
          <h4>Destinatario/a</h4>
          <p>{{ name_gen }}</p>
          <h4>Teléfono</h4>
          <p>{{ phone_gen }}</p>
          <h4 v-if='slotsize_gen'>Tamaño</h4>
          <p v-if='slotsize_gen'>{{ slotsize_gen }}</p>
          <h4> Usa el siguiente código para introducir el paquete</h4>
          <h2 class='no-margin-top' v-if='!scanner'>{{ dropoff_code }}</h2>
          <div class="center" v-if='scanner'>
            <qr :text="dropoff_code" whiteMargin v-bind:value="dropoff_code">
              {{ dropoff_code }}
            </qr>
            <h2 class='no-margin-top'>{{ dropoff_code }}</h2>
          </div>
          <i v-if="expiresAt">El código es válido hasta el día y hora <b>{{ expiresAt }}</b>. A partir de entonces será necesario generar un nuevo envío.</i>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import VueQr from 'vue-qr';
import sizeModule from '@/components/sizeModule.vue'
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'GenerateLocalParcel',
  data() {
    return {
      user: null,
      pass: null,
      admin_id: null,
      dropoff_code: null,
      scanner: false,
      robot: false,
      expiresAt: null,
      apmOptions: null,
      gpResponse: null,
      parcelInfo: {
        place_id: null,
        name: null,
        phone: null,
        email: null,
        slot_size: null,
        slot_size_text: null,
      },
      apm_selected: null,
      apm_selected_gen: null,
      name_gen: null,
      phone_gen: null,
      slotsize_gen: null,
      error: false,
      msg_error: null,
      parcelSizes: [],
    }
  },
  created() {
    let role = JSON.parse(localStorage.admin).role;
    this.admin_id = JSON.parse(localStorage.admin).id;
    if (role === 'master' || role === 'localUser' || role === 'localAdmin') {
      this.getData();
    } else {
      this.$router.replace('/parcels_v2')
    }
  },
  watch: {
    'parcelInfo.place_id': function(new_place_id, old_place_id) {
      this.parcelSizes = []
      this.apm_selected = this.apmOptions.find((e) => e.key == new_place_id).text
      this.robot = this.apmOptions.find((e) => e.key == new_place_id).robot
      if (!this.robot) {
        this.getEmptySlots(new_place_id)
      }
    }
  },
  methods: {
    getEmptySlots(place_id) {
      hapiickApi().post('/v1/apms/empty-slots', {
        admin_id: JSON.parse(localStorage.admin).id,
        place_id: place_id
      })
      .then((request)  => {
        this.loadApmCapacity(request.data.slots)
      })
      .catch((request) => console.log('error getting empty slots: ' + request))
    },
    getData() {
      hapiickApi().post('/v1/shipments/users', {
        admin_id: JSON.parse(localStorage.admin).id
      })
      .then((req)  => {
        this.loadData(req.data);
      })
      .catch((req) => console.log('error getting getDataGenerateLocalParcel: ' + req))
    },
    loadData(data) {
      this.loadApmUsers(data.apms);
    },
    loadApmUsers(apms) {
      let apmsList = JSON.parse(JSON.stringify(apms));
      if (apmsList.length === 0) {
        this.error = true;
        this.msg_error = 'Imposible generar envío: no tienes máquina asignada.';
        return;
      }
      this.apmOptions = apmsList.map(apm => ({
        key: apm.place_id,
        text: apm.LanguagesApts[0].name,
        value: apm.place_id,
        scanner: apm.AptModel.scanner,
        robot: apm.AptModel.robot,
      }));
      //console.log(this.apmOptions[0]);
      this.parcelInfo.place_id = this.apmOptions[0].key
     
    },
    loadApmCapacity(slots) {
      if (!slots) {
        this.error = true
        this.msg_error = 'No se ha podido conectar con la taquilla para obtener los huecos libres. Vuelva a intentarlo pasados unos minutos.'
      }
      let sizes = ['XS', 'S', 'S+', 'M', 'M+','MD','L','L+','LD','XL','XL+','DXL','XXL','XXL+','C']
      sizes['XS'] = '36x9x62'
      sizes['S'] = '36x12x62'
      sizes['M'] = '36x20x62'
      sizes['L'] = '36x38x62'
      sizes['XL'] = '36x60x62'
      this.parcelSizes = slots
        .map((slot, i) => {
          let sort = sizes.indexOf(slot.title);
          return {
            id: slot.size,
            text: slot.text.toUpperCase() || slot.size,
            dim: sizes[slot.size] || (!!(slot.width && slot.height && slot.depth) ? `${slot.width}x${slot.height}x${slot.depth}` : ''),
            empty: slot.empty,
            sort: sort
          }
        })
        .sort((a, b) => {
          return a.sort - b.sort
        });
      this.defaultSelected = this.getDefaultSelected();
    },
    generateParcel() {
      let tamanio = '';
      if (!this.robot) {
        tamanio = '<br /><br />' + '<b>Tamaño:</b>  ' + this.parcelInfo['slot_size_text'] + '<br /><br />';
      }

      this.$swal
        .fire({
          title: 'Confirmar envío',
          html: '<b>Taquilla:</b>  ' + this.apm_selected  + 
                '<br /><br />' + '<b>Destinatario/a:</b>  ' + this.parcelInfo['name']  + 
                '<br /><br />' + '<b>Teléfono:</b>  ' + this.parcelInfo['phone'] + 
                tamanio,
          type: 'question',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Confirmar'
        })
        .then((result) => {
          
          if (result.value) {
            this.generateLocalParcel()
            }
        })
    },
    generateLocalParcel(){
      //console.log('En generateLocalParcel')
      let x = document.getElementById("generate");
      x.classList.add("loading");
      x.disabled = true;

      this.dropoff_code = null;
      //this.generating = true;
      hapiickApi().post('/v1/locals/shipments/add', {
        admin_id: JSON.parse(localStorage.admin).id,
        parcelInfo: this.parcelInfo
      })
      .then(request => this.showResponse(request))
      .catch((request) => {
        this.error = true;
        this.msg_error = 'Se ha producido un error al generar el envío. Vuelve a iniciar sesión y prueba de nuevo.';
        console.log('error generating parcel: ' + request)
      })
    },
    showResponse(req) {
      //console.log(req)
      if ('status' in req.data) {
        this.error = true;
        this.msg_error = req.data.message;
        return;
      }
      this.apm_selected_gen = this.apm_selected
      this.name_gen = this.parcelInfo.name;
      this.phone_gen = this.parcelInfo.phone
      this.slotsize_gen = this.parcelInfo.slot_size_text
      // this.slotsize_gen = this.parcelInfo.slot_size
      
      this.scanner = this.apmOptions.find((e) => e.key == this.parcelInfo.place_id).scanner
      //console.log('this.scanner: '+this.scanner)

      let x = document.getElementById("generate");
      x.classList.remove("loading");
      x.disabled = false;
      //this.generating = false;
      this.dropoff_code = req.data.LocalShipment.dropoff_code;
      // this.dropoff_code = JSON.parse(JSON.stringify(req.data.LocalShipment)).dropoff_code;
      if (req.data.LocalShipment.expires) {
        this.expiresAt = req.data.LocalShipment.expires;
      }

      //vaciar campos
      this.parcelInfo.name = null
      this.parcelInfo.phone = null
      this.parcelInfo.email = null
      if (this.expiresAt) {
        this.parcelSizes = this.parcelSizes.map((a) => {
        if (a.id == this.parcelInfo.slot_size) {
          a.empty -= 1
        }
        return a
      })
      }
      
      // this.defaultSelected = this.parcelSizes.find((a) => a.empty > 0);
      // if (this.defaultSelected) {
      //   document.getElementById('generate').classList.remove('disabled');
      // } else {
      //   document.getElementById('generate').classList.add('disabled');
      // }
      this.defaultSelected = this.getDefaultSelected();
    
    },
    getDefaultSelected() {
      if (!this.robot) {
        let default_selected = this.parcelSizes.find((a) => a.empty > 0);
        if (default_selected) {
          document.getElementById('generate').classList.remove('disabled');
        } else {
          document.getElementById('generate').classList.add('disabled');
        }
        return default_selected
      }
    },
    sizeSelected(event){
      this.parcelInfo.slot_size = event.id
      this.parcelInfo.slot_size_text = event.text
    },
    goTo(where) {
      this.$router.push(where)
    }
  },
  components: {
    'qr': VueQr,
    'sizeModule': sizeModule
  }
}
</script>
<style scoped>
.erdian {
  border-style: solid;
  border-radius: 0.1px;
  border-color: var(--var-color);
  text-align: center;
}
.center {
  text-align: center;
}
.no-margin-top {
  margin-top: 0;
}
.no-padding {
  padding-left: 0px;
  padding-right: 0px;
}
.segment {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/GenerateLocalParcel.vue